import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getVehicleCountByMonth = createAsyncThunk(
  'dashboard/getVehicleCountByMonth',
  async ({ count }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/vehicle/get-vehicle-count-by-month/${count}`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const getSales = createAsyncThunk(
  'dashboard/getSalePaymnets',
  async ({ months, agent_id }, { rejectWithValue }) => {
    try {
      const params = {};
      if (agent_id) params.agent_id = agent_id;
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/vehicle/get-last-months-vehicle-sales/${months}`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const getOnSaleCount = createAsyncThunk(
  'dashboard/getOnSaleCount',
  async (_, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/vehicle/get-on-sale-vehicle-count`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const getSoldCount = createAsyncThunk(
  'dashboard/getSoldCount',
  async (_, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/vehicle/get-sold-vehicle-count`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const getOrderCountByMonth = createAsyncThunk(
  'dashboard/getOrderCountByMonth',
  async ({ month, agent_id }, { rejectWithValue }) => {
    try {
      const params = {};
      if (agent_id) params.agent_id = agent_id;
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/orders/get-order-count-by-month/${month}`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const getOrderCountByPreviousMonth = createAsyncThunk(
  'dashboard/getOrderCountByPreviousMonth',
  async ({ month, agent_id }, { rejectWithValue }) => {
    try {
      const params = {};
      if (agent_id) params.agent_id = agent_id;
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/orders/get-order-count-by-month/${month}`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);